import * as React from "react"
// useStaticQuery, graphql,
import { Link } from "gatsby"

import SafeAreaWrapper from "./SafeAreaWrapper"
import SocialMedia from "./SocialMedia"
import Grid from "./Grid"

import scrollTo from "gatsby-plugin-smoothscroll"

const DownloadIcon = ({ className }) => (
	<svg
		width="12"
		height="12"
		viewBox="0 0 12 12"
		xmlns="http://www.w3.org/2000/svg"
		className={`inline-block fill-current ${className}`}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6.66602 7.05719L9.52794 4.19526L10.4708 5.13807L5.99935 9.60948L1.52794 5.13807L2.47075 4.19526L5.33268 7.05719V0H6.66602V7.05719ZM11.3327 10.6667V12H0.666016V10.6667H11.3327Z"
			fill="currentColor"
		/>
	</svg>
)

const Footer = ({ showFull = true, className = "" }) => {
	return (
		<footer className={className}>
			<SafeAreaWrapper className="bg-porcelain border-iron border-b">
				{showFull && (
					<>
						<Grid className="relative">
							<div className="col-span-12">
								<div className="absolute top-0 flex w-full flex-col items-center lg:items-end">
									<div
										className="relative hover:cursor-pointer"
										onClick={() => {
											scrollTo("main")
										}}
										onKeyDown={() => {
											scrollTo("main")
										}}>
										<svg
											width="108"
											height="34"
											xmlns="http://www.w3.org/2000/svg"
											className="fill-current text-white">
											<path
												d="M.418 0C12.53.048 16.325 2.793 21.246 9.832 30.74 23.414 37.522 33.37 54 33.42h.124c16.479-.05 23.259-10.006 32.755-23.588C91.799 2.793 95.594.048 107.706 0H.418z"
												fillRule="evenodd"
											/>
										</svg>

										<svg
											width="18"
											height="21"
											xmlns="http://www.w3.org/2000/svg"
											className="text-pictonblue absolute top-0 left-0 right-0 mx-auto fill-current hover:text-tealblue hover:-top-10 transition-all duration-300 ease-in-out">
											<path
												fillRule="nonzero"
												d="M8.56 0l8.561 8.56L15 10.681l-4.94-4.938V21h-3V5.743l-4.939 4.938L0 8.561z"
											/>
										</svg>
									</div>
								</div>
							</div>
						</Grid>

						{/* pt-120 px-20 md:px-0 pb-80 md:pb-100 lg:pb-60 */}
						<Grid className="border-iron border-b pt-80 pb-80 gap-y-40 lg:gap-y-0">
							{/* <div className="md:order-1 xl:order-4 col-span-12 xl:col-span-5 xl:col-start-8">
								<p className="text-base sm:text-center md:text-left mb-40">
									Join hundreds of fleet managers, inspectors and ship owners.
								</p>
								<a
									href={process.env.GATSBY_NEWSLETTER_SUBSCRIPTION_URL}
									target="_blank"
									rel="noreferrer">
									<Button
										primary
										className="sm:mb-40 lg:mb-0 w-full lg:w-auto"
										label="Subscribe to newsletter"
									/>
								</a>
							</div> */}

							<div className="col-span-12 lg:col-span-3">
								<ul>
									<li className="text-jetblack mb-20 text-base font-bold">
										Company
									</li>
									<li className="text-md text-jetblack mb-20">
										<Link
											className="whitespace-nowrap hover:underline"
											to="/hanseaticsoft">
											About Hanseaticsoft
										</Link>
									</li>
									<li className="text-md text-jetblack mb-20">
										<Link
											className="whitespace-nowrap hover:underline"
											to="/contact">
											Contact
										</Link>
									</li>
									<li className="text-md text-jetblack mb-20">
										<Link
											className="whitespace-nowrap hover:underline"
											to="/customers">
											Customers
										</Link>
									</li>
									<li className="text-md text-jetblack">
										<Link
											className="whitespace-nowrap hover:underline"
											to="/press">
											Press Coverage
										</Link>
									</li>
								</ul>
							</div>

							<div className="col-span-12 lg:col-span-3">
								<ul>
									<li className="text-jetblack mb-20 text-base font-bold">
										Product
									</li>
									{/* <li className="text-md text-jetblack hover:underline mb-20">
										<Link to="/mobile-apps">Mobile apps</Link>
									</li> */}
									<li className="text-md text-jetblack mb-20">
										<Link
											className="hover:underline"
											to="/ai"
											data-umami-event="click-learn-more-about-ai-features">
											AI Features
										</Link>
									</li>
									<li className="text-md text-jetblack mb-20">
										<Link
											className="whitespace-nowrap hover:underline"
											to="/certifications">
											Certifications
										</Link>
									</li>
									<li className="text-md text-jetblack mb-20">
										<Link className="hover:underline" to="/new-features">
											New Features
										</Link>
									</li>
									<li className="text-md text-jetblack mb-20">
										<Link
											className="whitespace-nowrap hover:underline"
											to="/faq">
											FAQ
										</Link>
									</li>
									<li className="text-md text-jetblack mb-20">
										<Link
											className="whitespace-nowrap hover:underline"
											to="/integrations">
											Integrations
										</Link>
									</li>
									<li className="text-md text-jetblack">
										<Link
											className="whitespace-nowrap hover:underline"
											to="/system-requirements">
											System requirements
										</Link>
									</li>
								</ul>
							</div>

							<div className="col-span-12 lg:col-span-3">
								<ul>
									<li className="text-jetblack mb-20 text-base font-bold">
										Downloads
									</li>

									<li className="text-md text-jetblack mb-20 whitespace-nowrap">
										<a
											href="/Cloud-Fleet-Manager-Product-Brochure.pdf"
											data-umami-event="download-product-brochure"
											className="hover:underline"
											download>
											Brochure
										</a>{" "}
										<DownloadIcon />
									</li>
									<li className="text-md text-jetblack mb-20 whitespace-nowrap">
										<a
											href="/Cloud-Fleet-Manager-Fact-Sheets.zip"
											data-umami-event="download-product-fact-sheets"
											className="hover:underline"
											download>
											Fact Sheets
										</a>{" "}
										<DownloadIcon />
									</li>
									<li className="text-md text-jetblack mb-20 whitespace-nowrap">
										<a
											href="/Cloud-Fleet-Manager-Mobile-Apps-Fact-Sheet.pdf"
											data-umami-event="download-mobile-apps-fact-sheet"
											className="hover:underline"
											download>
											Mobile Apps Fact Sheet
										</a>{" "}
										<DownloadIcon />
									</li>
									<li className="text-md text-jetblack whitespace-nowrap">
										<Link to="/wallpapers" className="hover:underline">
											Wallpapers
										</Link>
									</li>
								</ul>
							</div>

							{/* <div className="sm:order-4 xl:order-1 col-span-12 xl:col-span-3 mt-40 md:mt-50 lg:mt-60 xl:mt-0"></div> */}
						</Grid>
					</>
				)}
				<Grid className="py-10">
					<div className="col-span-12 flex flex-row flex-wrap items-center">
						<div className="w-full lg:w-auto md:order-1 lg:order-3 mb-10 lg:mb-0">
							<SocialMedia />
						</div>

						<ul className="flex flex-grow flex-row lg:order-2 my-10 w-full md:w-auto md:order-3 justify-center lg:justify-start">
							<li className="text-nevada hover:underline md:ml-20 text-sm">
								<Link to="/imprint">Imprint</Link>
							</li>
							<li className="text-nevada hover:underline ml-20 text-sm">
								<Link to="/privacy">Privacy Policy</Link>
							</li>
							<li className="text-nevada hover:underline ml-20 text-sm">
								<Link to="/terms">Terms of Service</Link>
							</li>
							<li className="text-nevada hover:underline ml-20 text-sm">
								<a
									href="/dpa"
									alt="Agreement on data processing for Cloud Fleet Manager"
									title="Data Processing Agreement"
									target="_blank"
									rel="noreferrer">
									DPA
								</a>
							</li>
						</ul>

						<div className="lg:order-1 my-10 w-full md:w-auto md:order-2 text-nevada text-sm text-center lg:text-left">
							&copy; {new Date().getFullYear()} Hanseaticsoft GmbH
						</div>
					</div>
				</Grid>
			</SafeAreaWrapper>
		</footer>
	)
}

export default Footer
